<page-section sectionTitle="Education">
  <div class="col">
    <app-timeline [timelineItems]="schools"></app-timeline>
  </div>
</page-section>
